import React from 'react'

// Hooks
import { createContext, useState } from "react";

// @ts-ignore
export const DataContext = createContext();

export default function CartProvider({ children }) {
    const [items, setItems] = useState(JSON.parse(localStorage.getItem("cart")) || []);

    return (
        <DataContext.Provider value={{ items, setItems }}>
            {children}
        </DataContext.Provider>
    )
}
